import React from 'react';
import { DataGrid, GridColDef, GridPanelProps } from '@mui/x-data-grid';
import { Button, Container, Box, Grid, Typography, Paper, Stack } from '@mui/material';



import * as Api from "api/api"
import * as ProductsApi from 'api/products'

import ErrorMessage from 'tsui/ErrorMessage'

import InputBase from '@mui/material/InputBase';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import DirectionsIcon from '@mui/icons-material/Directions';
import ProductDetailsTab from './ProductDetailsTab';
import AddProductDialog from './AddProductDialog';


export class ProductsData {
    productId: string;
    productCardType: string;

    // productPrice: string;
    productAmount: string;
    productCurrency: string;
    productCurrencyCode: string;
    productPrice: ProductsApi.ApiProductPrice[];



    constructor(p: ProductsApi.ApiProducts) {
        this.productId = p.productId;
        this.productCardType = p.productCardType;
        this.productPrice = p.productPrice
        // this.productPrice = p.productPrice
        this.productAmount = ''
        this.productCurrency = ''
        this.productCurrencyCode = ''
        for (let productPrice of p.productPrice) {
            this.productAmount += `${productPrice.amount.toString()}, `
            this.productCurrency += `${productPrice.currency}, `
            this.productCurrencyCode += `${productPrice.currencyCode}, `
        }


    }
}

export default function ProductsTab() {

    const mounted = React.useRef(false);
    let [dataRequested, setDataRequested] = React.useState(false);
    let [error, setError] = React.useState<Error | null>(null);
    let [products, setProducts] = React.useState<ProductsApi.ApiProducts[]>();
    let [productDetailsId, setProductDetailsId] = React.useState<string | null>(null);

    let [addProduct, setAddProduct] = React.useState(false);

    const [searchVal, setSearchVal] = React.useState('');


    React.useEffect(() => {
        mounted.current = true;
        if (!dataRequested) {
            Api.requestAdmin<ProductsApi.ApiProducts[]>('products', 'fetch', {}).then(products => {
                if (mounted.current) {
                    console.log('products', products)
                    let productsData: ProductsData[] = [];
                    for (let p of products) {
                        productsData.push(new ProductsData(p));
                    }
                    setProducts(productsData);
                }
            }).catch(setError);
            setDataRequested(true);
            return;
        }
        return () => { mounted.current = false }
    }, [dataRequested]);


    if (error) {
        console.debug(error);
        return <ErrorMessage error={error} />
    }

    if (!products) {
        return <></>
    }

    //console.log('userDetailsId', productDetailsId)
    /*
    function RenderUser(user: UsersApi.ApiUser, index: number) {
        return <tr key={index}>
            <td>{user.userId}</td>
            <td>{user.firstName}</td>
            <td>{user.lastName}</td>
            <td>{user.email}</td>
            <td>{user.phone}</td>
            <td>
                <Button onClick={() => setShownUserIndex(index)}>Details</Button>
                <Button onClick={() => setEditedUserIndex(index)}>Edit</Button>
            </td>
        </tr>
    }
    */


    return <>
        <Stack direction='column' height='100%' alignItems='center' spacing={2}>
            <Button onClick={() => {setAddProduct(true)}} sx={{backgroundColor: theme_.themeColor, color: theme_.inputTextBackgroundColor}}>Add Product</Button>
            {/* <Stack direction='row' width='100%' spacing={2} alignItems='center'>
                <Typography>Total Users:&nbsp;{products.length}</Typography>

                <Paper
                    component="form"
                    sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 400 }}
                >
                    <InputBase
                        sx={{ ml: 1, flex: 1 }}
                        placeholder="Search"
                        inputProps={{ 'aria-label': 'search google maps' }}
                        onChange={e => setSearchVal(e.target.value)}
                        value={searchVal}
                    />
                    <IconButton type="button" sx={{ p: '10px' }} aria-label="search">
                        <SearchIcon />
                    </IconButton>
                    <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                    <Button onClick={() => setDataRequested(false)}>
                        <DirectionsIcon />
                    </Button>
                </Paper>

            </Stack> */}



            <DataGrid
                sx={{
                    width: '100%',
                    color: theme_.dataGridTextColor
                }}
                columns={[
                    { field: 'productId', headerName: 'Product Id', headerAlign: 'center', width: 80 },
                    { field: 'productCardType', headerName: 'Card Type', headerAlign: 'center', width: 250 },
                    { field: 'productAmount', headerName: 'Amount', headerAlign: 'center', width: 250 },
                    { field: 'productCurrency', headerName: 'Currenct', headerAlign: 'center', minWidth: 300, flex: 1 }, // width: 600 },
                    { field: 'productCurrencyCode', headerName: 'Currency Code', headerAlign: 'center', minWidth: 80, flex: 1 },

                    {
                        field: '', type: 'actions', headerName: 'Actions', width: 100, renderCell: (cell) => {
                            return <>
                                <Button variant='contained' onClick={() => setProductDetailsId(cell.id as string)}>Change</Button>
                                {/* <Button onClick={() => setEditedUserIndex(cell.id as string)}>Edit</Button> */}
                            </>;
                        }
                    }, // width: 600 },
                ]}
                rows={products}
                //autoHeight

                autoPageSize={true}
                disableRowSelectionOnClick
                getRowId={row => row.productId}
            />
        </Stack>

        {productDetailsId && <ProductDetailsTab productId={productDetailsId} onClose={() => { setProductDetailsId(null); setDataRequested(false) }} />}
        {addProduct && <AddProductDialog onClose={() => { setAddProduct(false); setDataRequested(false) }}/>}
    </>;
}


